/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from "@cian/http-api/shared/model";

export type TBookCoworkingModel = IModel<
  IBookCoworkingRequest,
  TBookCoworkingResponse
>;

export interface IBookCoworkingRequest {
  /** ID коворкинга **/
  coworkingId: number;
  /** Тип объявления в коворкинге **/
  coworkingOfferType: ECoworkingOfferType;
  /** Запрос от брокера **/
  isBroker: boolean;
  /** Имя пользователя **/
  name: string;
  /** Телефон пользователя **/
  phone: string;
  /** Срок аренды **/
  rentDuration: number;
  /** Единица измерения срока аренды **/
  rentDurationUnit: ERentDurationUnit;
  /** Дата начала аренды **/
  rentStartDate: string;
  /** Количество рабочих мест **/
  workplaceCount: number;
}

export type TBookCoworkingResponse =
  | IBookCoworkingResponse200
  | IBookCoworkingResponse400;

export interface IBookCoworkingResponse200
  extends IModelResponse<IBookCoworkingResponse> {
  statusCode: 200;
}

export interface IBookCoworkingResponse400
  extends IModelResponse<IBookCoworkingResponseError> {
  statusCode: 400;
}

export interface IBookCoworkingResponse {
  /** Бронирование успешно создано **/
  status: string;
}

export interface IBookCoworkingResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IBookCoworkingResponse | IBookCoworkingResponseError;

export enum ECoworkingOfferType {
  /** Закрепленное рабочее место **/
  FixedWorkplace = "fixedWorkplace",
  /** Незакрепленное рабочее место **/
  FlexibleWorkplace = "flexibleWorkplace",
  /** Гибкий офис **/
  Office = "office"
}

export enum ERentDurationUnit {
  /** День **/
  Day = "day",
  /** Месяц **/
  Month = "month"
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IBookCoworkingResponse): TResponse200;
  400(response: IBookCoworkingResponseError): TResponse400;
}
